import { FormEvent, useState } from 'react';

export interface ContactValues {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

type Errors = Partial<Record<keyof ContactValues, string>>;
type Status = 'idle' | 'submitting' | 'success';

const initialValues: ContactValues = {
  name: '',
  email: '',
  phone: '',
  subject: 'Afspraak voor intake',
  message: '',
};

export function useContactForm() {
  const [values, setValues] = useState<ContactValues>(initialValues);
  const [errors, setErrors] = useState<Errors>({});
  const [status, setStatus] = useState<Status>('idle');

  const update = (field: keyof ContactValues, value: string) => {
    setValues((v) => ({ ...v, [field]: value }));
    if (errors[field]) setErrors((e) => ({ ...e, [field]: undefined }));
  };

  const validate = (): Errors => {
    const next: Errors = {};
    if (!values.name.trim()) next.name = 'Vul uw naam in.';
    if (!values.email.trim()) next.email = 'Vul uw e-mailadres in.';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) next.email = 'Vul een geldig e-mailadres in.';
    if (values.message.trim().length < 10) next.message = 'Beschrijf uw vraag in minimaal 10 tekens.';
    return next;
  };

  const submit = (event: FormEvent) => {
    event.preventDefault();
    const next = validate();
    setErrors(next);
    if (Object.keys(next).length > 0) return;
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };

  const reset = () => {
    setValues(initialValues);
    setErrors({});
    setStatus('idle');
  };

  return { values, errors, status, update, submit, reset };
}
